import React from "react";
import { Star } from "lucide-react";

// Small rating line under each plan button; renders nothing until a real review badge exists.
export default function PlanRating({ badge, id }) {
  if (!badge) return null;
  const platform = badge.platform === "g2" ? "G2" : "Trustpilot";
  return (
    <a
      href={badge.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`${id}-rating`}
      className="mt-3 flex items-center justify-center gap-2 font-sans text-xs text-bone-400 hover:text-terracotta transition-colors"
    >
      <Star className="h-3.5 w-3.5 fill-terracotta text-terracotta" aria-hidden="true" />
      <span>
        {badge.rating.toFixed(1)} on {platform} · {badge.count.toLocaleString()} review{badge.count === 1 ? "" : "s"}
      </span>
    </a>
  );
}
